import React from 'react';
import {
  Paper,
  Box,
  Typography,
  Button,
  Stack,
  TextField,
  MenuItem,
  Autocomplete
} from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';

const FilterPanel = ({ 
  filters, 
  onFilterChange, 
  onClearFilters, 
  filterConfig = [],
  title = "Filters"
}) => {
  const hasActiveFilters = Object.values(filters).some(v => v !== '');

  const renderFilterField = (config) => {
    const { field, label, type = 'select', options = [], ...rest } = config;
    
    if (type === 'select') {
      return (
        <TextField 
          key={field}
          select 
          label={label} 
          size="small" 
          value={filters[field] || ''} 
          onChange={(e) => onFilterChange(field)(e)}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: 'background.paper'
            }
          }}
          {...rest}
        >
          <MenuItem value="">All {label}</MenuItem>
          {Array.isArray(options) && options.map(option => (
            <MenuItem key={option.value || option.id} value={option.value || option.id}>
              {option.label || option.name || option}
            </MenuItem>
          ))}
        </TextField>
      );
    }

    if (type === 'text') {
      return (
        <TextField 
          key={field}
          label={label} 
          size="small" 
          value={filters[field] || ''} 
          onChange={(e) => onFilterChange(field)(e)}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: 'background.paper'
            }
          }}
          {...rest}
        />
      );
    }

    if (type === 'autocomplete') {
      const { options = [], getOptionLabel, ...autocompleteProps } = rest;
      return (
        <Autocomplete
          key={field}
          freeSolo
          options={options}
          value={filters[field] || ''}
          onInputChange={(event, newInputValue) => {
            onFilterChange(field)({ target: { value: newInputValue } });
          }}
          onChange={(event, newValue) => {
            onFilterChange(field)({ target: { value: newValue || '' } });
          }}
          getOptionLabel={getOptionLabel || ((option) => option || '')}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              size="small"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  backgroundColor: 'background.paper'
                }
              }}
            />
          )}
          {...autocompleteProps}
        />
      );
    }

    return null;
  };

  return (
    <Paper 
      elevation={2} 
      sx={{ 
        p: 3, 
        borderRadius: 3,
        height: 'fit-content',
        position: 'sticky',
        top: 20,
        backgroundColor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
          {title}
        </Typography>
        <Button
          size="small"
          startIcon={<ClearIcon />}
          onClick={onClearFilters}
          disabled={!hasActiveFilters}
          sx={{ 
            textTransform: 'none',
            color: 'text.secondary',
            '&:hover': { color: 'error.main' }
          }}
        >
          Clear All
        </Button>
      </Box>
      
      <Stack spacing={3}>
        {filterConfig.map(renderFilterField)}
      </Stack>
    </Paper>
  );
};

export default FilterPanel; 